import { Box, Typography } from "@mui/material";

/**
 * フォームの情報
 */
const headTitleList: any[] = [
  {
    headTitle: (
      <Box>
        <Typography>契約者名</Typography>
        <Typography>施設名</Typography>
      </Box>
    ),
    className: "tkAnySearchTableResultItem",
    align: "left",
    dontNeedSort: false,
    index: 0,
  },
  {
    headTitle: (
      <Box>
        <Typography>契約者住所</Typography>
        <Typography>施設住所</Typography>
      </Box>
    ),
    className: "tkAnySearchTableResultItem",
    align: "left",
    dontNeedSort: true,
  },
  {
    headTitle: (
      <Box>
        <Typography>施設種類</Typography>
        <Typography>◎···制度改正前開設</Typography>
      </Box>
    ),
    className: "tkAnySearchTableResultItem",
    align: "left",
    dontNeedSort: true,
  },
  {
    headTitle: (
      <Box>
        <Typography>職員氏名</Typography>
        <Typography>生年月日　性別</Typography>
      </Box>
    ),
    className: "tkAnySearchTableResultItem",
    align: "left",
    dontNeedSort: true,
  },
  {
    headTitle: (
      <Box>
        <Typography>加入日</Typography>
        <Typography>退職日</Typography>
      </Box>
    ),
    className: "tkAnySearchTableResultItem",
    align: "center",
    dontNeedSort: true,
  },
  {
    headTitle: (
      <Box>
        <Typography>施設一覧</Typography>
      </Box>
    ),
    className: "tkAnySearchTableResultItem",
    align: "center",
    dontNeedSort: true,
  },
  {
    headTitle: (
      <Box>
        <Typography>職員一覧</Typography>
      </Box>
    ),
    className: "tkAnySearchTableResultItem",
    align: "center",
    dontNeedSort: true,
  },
];

export { headTitleList };
